import React from 'react';
import colors from '../../../Utils/colors';
import images from '../../../Utils/images';

interface EmailTemplate {
  _id: string;
  emailName: string;
  description?: string;
  updatedAt?: string | Date;
  previewImage?: string;
}

interface EmailTemplateCardProps {
  template: EmailTemplate;
  onClick?: (template: EmailTemplate) => void;
  showButton?: boolean;
  buttonText?: string;
}

const EmailTemplateCard: React.FC<EmailTemplateCardProps> = ({
  template,
  onClick,
  showButton = true,
  buttonText = 'Use Template',
}) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onClick) {
      onClick(template);
    }
  };

  return (
    <div className="email-template-card">
      <div style={{
        display: 'flex',
        padding: '16px',
        flex: 1
      }}>
        <div style={{
          width: '120px',
          borderRadius: '6px',
          backgroundColor: '#F3F4F6',
          overflow: 'hidden',
          flexShrink: 0,
          marginRight: '16px'
        }}>
          <img
            src={images.CATemplate}
            alt={template.emailName}
            style={{
              width: '100%',
              objectFit: 'contain'
            }}
          />
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <p
            className="header_text"
            style={{
              margin: 0,
              padding: 0,
              fontSize: 16,
              fontWeight: 600,
              color: colors.black,
              marginBlock: 4,
            }}
          >
            {template.emailName}
          </p>
          <div style={{
            fontSize: '13px',
            color: '#6B7280',
            marginBottom: '8px',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}>
            {template.description || 'No description available'}
          </div>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            fontSize: '12px',
            color: '#6B7280',
            marginTop: 'auto'
          }}>
            <i className="far fa-calendar-alt" style={{ marginRight: '4px' }} />
            <span>
              {new Date(template.updatedAt || new Date()).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
              })}
            </span>
          </div>
        </div>
      </div>
      {showButton && (
        <div style={{
          borderTop: '1px solid #F3F4F6',
          padding: '12px 16px',
          display: 'flex',
          justifyContent: 'flex-end'
        }}>
          <button
            onClick={handleClick}
            className="template-button"
            style={{
              backgroundColor: colors.primary03,
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              padding: '6px 12px',
              fontSize: '13px',
              fontWeight: 500,
              cursor: 'pointer'
            }}
          >
            {buttonText}
          </button>
        </div>
      )}
    </div>
  );
};

export default EmailTemplateCard;
